import { Injectable } from '@angular/core';
import {
    AbstractControl,
    AsyncValidator, AsyncValidatorFn,
    ValidationErrors,
} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {catchError, map, take} from 'rxjs/operators';
import {AuthWebService} from '../services/authweb.service';
@Injectable({
    providedIn: 'root',
})
export class EmailExistsValidator implements AsyncValidator {
    constructor(private auth: AuthWebService) {}

    validate = (control: AbstractControl): Observable<ValidationErrors | null> => {

          return this.auth.isEmailTaken(control.value).pipe(
            map((response: boolean) => {
                console.log("Email response");
                if (response) {
                    return { emailexists: true };
                } else {
                    return null;
                }
            }),
            catchError(() => of({ emailexists: true }))
        );
    };

}
